<template>
  <div>
    <div class="d-flex">
      <b-button
        :variant="getButtonVariant('overview')"
        size="sm"
        :class="`mr-1 flex-fill ${buttonPaddingClass} d-flex align-items-center justify-content-center`"
        @click="scrollToSection('overview')"
      >
        <feather-icon
          icon="BookOpenIcon"
          size="16"
          class="mr-50"
        />
        <span style="transform: translateY(1px)">Overview</span>
      </b-button>
      <b-button
        :variant="getButtonVariant('key-information')"
        size="sm"
        :class="`mr-1 flex-fill ${buttonPaddingClass} d-flex align-items-center justify-content-center`"
        @click="scrollToSection('key-information')"
      >
        <feather-icon
          icon="InfoIcon"
          size="16"
          class="mr-50"
        />
        <span style="transform: translateY(1px)">Key Information</span>
      </b-button>
      <b-button
        :variant="getButtonVariant('documentation')"
        size="sm"
        :class="`mr-1 flex-fill ${buttonPaddingClass} d-flex align-items-center justify-content-center`"
        @click="scrollToSection('documentation')"
      >
        <feather-icon
          icon="FileTextIcon"
          size="16"
          class="mr-50"
        />
        <span style="transform: translateY(1px)">Documentation</span>
      </b-button>
      <b-button
        :variant="getButtonVariant('analysis')"
        size="sm"
        :class="`mr-1 flex-fill ${buttonPaddingClass} d-flex align-items-center justify-content-center`"
        @click="scrollToSection('analysis')"
      >
        <feather-icon
          icon="BarChart2Icon"
          size="16"
          class="mr-50"
        />
        <span style="transform: translateY(1px)">Analysis</span>
      </b-button>
      <b-button
        :variant="getButtonVariant('compliance')"
        size="sm"
        :class="`mr-1 flex-fill ${buttonPaddingClass} d-flex align-items-center justify-content-center`"
        @click="scrollToSection('compliance')"
      >
        <feather-icon
          icon="CheckCircleIcon"
          size="16"
          class="mr-50"
        />
        <span style="transform: translateY(1px)">Compliance</span>
      </b-button>
      <b-button
        :variant="getButtonVariant('lifecycle')"
        size="sm"
        :class="`mr-1 flex-fill ${buttonPaddingClass} d-flex align-items-center justify-content-center`"
        @click="scrollToSection('lifecycle')"
      >
        <feather-icon
          icon="ActivityIcon"
          size="16"
          class="mr-50"
        />
        <span style="transform: translateY(1px)">Lifecycle</span>
      </b-button>
      <b-button
        :variant="getButtonVariant('provider')"
        size="sm"
        :class="`flex-fill ${buttonPaddingClass} d-flex align-items-center justify-content-center`"
        @click="scrollToSection('provider')"
      >
        <feather-icon
          icon="BriefcaseIcon"
          size="16"
          class="mr-50"
        />
        <span style="transform: translateY(1px)">Provider</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import {
  BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BButton,
  },
  props: {
    inStickyBar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeSection: 'overview',
    }
  },
  computed: {
    buttonPaddingClass() {
      return this.inStickyBar ? 'py-1' : 'py-1' // can customise padding sticky bar buttons
    },
  },
  mounted() {
    window.addEventListener('scroll', this.updateActiveSection)
    this.updateActiveSection()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateActiveSection)
  },
  methods: {
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        const yOffset = -140 // offset for fixed header/navbar
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
        window.scrollTo({
          top: y,
          behavior: 'smooth',
        })
      }
    },
    updateActiveSection() {
      const sections = ['overview', 'key-information', 'documentation', 'analysis', 'compliance', 'lifecycle', 'provider']
      const scrollPosition = window.pageYOffset + 100

      // check if scrolled to bottom of page - if so, always highlight last section
      const scrolledToBottom = (window.innerHeight + window.pageYOffset) >= (document.documentElement.scrollHeight - 10)
      if (scrolledToBottom) {
        this.activeSection = sections[sections.length - 1]
        return
      }

      for (let i = sections.length - 1; i >= 0; i -= 1) {
        const element = document.getElementById(sections[i])
        if (element) {
          const { offsetTop } = element
          if (scrollPosition >= offsetTop) {
            this.activeSection = sections[i]
            break
          }
        }
      }
    },
    getButtonVariant(sectionId) {
      return this.activeSection === sectionId ? 'primary' : 'outline-secondary'
    },
  },
}
</script>
